/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { hooksGetStatus } from "../funcs/hooksGetStatus.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { HooksStatus } from "../models/components/hooksstatus.js";
import {
  GetHooksStatusRequest,
  GetHooksStatusSecurity,
} from "../models/operations/gethooksstatus.js";
import { unwrapAsync } from "../types/fp.js";
export type GetHooksStatusQueryData = HooksStatus;

export function prefetchGetHooksStatus(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetHooksStatusRequest | undefined,
  security?: GetHooksStatusSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetHooksStatusQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetHooksStatusQuery(
  client$: GramCore,
  request?: GetHooksStatusRequest | undefined,
  security?: GetHooksStatusSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetHooksStatusQueryData>;
} {
  return {
    queryKey: queryKeyGetHooksStatus({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function getHooksStatusQueryFn(
      ctx,
    ): Promise<GetHooksStatusQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(hooksGetStatus(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetHooksStatus(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "hooks", "getStatus", parameters];
}
